const getUseCaseMatrix = {
  gateway: 'Gateway',
  'power-outage': 'Power Outage',
  ambient: 'Room Temperature',
  ammonia: 'Ammonia Detection',
  refrigerator: 'Refrigerator',
  freezer: 'Freezer',
  'cold-storage': 'Cold Storage',
  'fine-wine': 'Fine Wine',
  'pipe-freeze': 'Pipe Freeze',
  water: 'Water',
  'pipe-monitoring': 'Pipe Monitoring',
  'boiler-blowdown': 'Boiler Blowdown',
  'fire-pump': 'Fire Pump',
  'leak-freeze': 'Leak & Freeze',
  'mold-conditions': 'Mold Conditions',
  'server-room-monitoring': 'Server Room Monitoring',
  ting: 'Ting',
  'water-shutoff': 'Water Shutoff',
  '': 'Unknown Use Case',
} as Record<DeviceUseCaseType | '', string>

export const getUseCase = (name: DeviceUseCaseType): UseCaseType => {
  return {
    name,
    vanity: getUseCaseMatrix[name],
  }
}

export default getUseCaseMatrix
